import { motion } from "framer-motion";

// Generic scroll-in reveal
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line heading reveal
export const MaskedLines = ({ lines, className = "", lineClassName = "", start = 0.15 }) => (
  <span className="block">
    {lines.map((line, i) => (
      <span key={i} className="reveal-line">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{
            duration: 1,
            delay: start + i * 0.12,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Label with acid square marker
export const Label = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] font-bold text-zinc-500 ${className}`}
  >
    <span className="w-2 h-2 bg-acid" aria-hidden="true" />
    {children}
  </span>
);
